import mitt from "mitt";

const emitter = {};
emitter.global = mitt();

export default emitter;
export { mitt };
